'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * This converts date in ISO format (e.g "2020-04-15T09:54:26+02:00") to short date format (15/04/2020)
 * the returned date format is DD/MM/YYYY
 * @param dateString
 */
var formatDate = function (dateString) {
    var dateArray = dateString.slice(0, 10).split('-');
    var year = dateArray[0], month = dateArray[1], day = dateArray[2];
    return day + "/" + month + "/" + year;
};

var normalizeWhitespaces = function (text) { return text.replace(/[\u202F\u00A0\u2000\u2001\u2003]/g, ' '); };
// replace dot with commas
var replaceDotWithCommas = function (num) { return num.replace('.', ','); };
// return number with provided character as thousand separator
var thousandSeparator = function (separator) { return function (num) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);
}; };
var normalizeNumber = function (text) { return replaceDotWithCommas(normalizeWhitespaces(text)); };
// custom format override method for es-ES.
var formatESNumber = function (text) { return thousandSeparator('.')(normalizeNumber(text)); };
// custom format override method for pl-PL.
var formatPLNumber = function (text) { return thousandSeparator(' ')(normalizeNumber(text)); };
// mapper for custom formatters
var customFormatter = {
    'es-ES': formatESNumber,
    'pl-PL': formatPLNumber,
};
/**
 * @param {string}  countryCode - if an empty string is passed then the method will return the passed price as a string without transformations
 * @param {string} currency - if an empty string is passed then the method will return the passed price as a string without transformations
 */
var formatPrice = function (countryCode, currency, price) {
    if (countryCode === '' || currency === '') {
        return String(price);
    }
    var hasDecimalPlaces = price % 1 !== 0;
    var num = new Intl.NumberFormat(countryCode, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: hasDecimalPlaces ? 2 : 0,
        maximumFractionDigits: 2,
    }).format(price);
    // see if the country code has any custom override method else return the value
    return customFormatter[countryCode] ? customFormatter[countryCode](num) : num;
};

var constants = {
    WEEK_LIMIT_IN_DAYS: 10,
    WEEK_LIMIT_IN_DAYS_CLUB: 14,
    DAYS_PER_WEEK: 5,
    DAYS_PER_WEEK_CLUB: 7,
};
var getMaxWeeks = function (origin, maxDays, daysPerWeek) {
    // club uses the max for weeks i.e 3.1 weeks ==> 4 weeks
    return origin === 'shop' ? Math.round(maxDays / daysPerWeek) : Math.ceil(maxDays / daysPerWeek);
};
var getDefaultWeekLimitInDays = function (origin) {
    return origin === 'shop' ? constants.WEEK_LIMIT_IN_DAYS : constants.WEEK_LIMIT_IN_DAYS_CLUB;
};
var getDefaultDaysPerWeek = function (origin) {
    return origin === 'shop' ? constants.DAYS_PER_WEEK : constants.DAYS_PER_WEEK_CLUB;
};
var formatDeliveryTime = function (t, data, origin) {
    if (origin === void 0) { origin = 'shop'; }
    var minDays = data.minDays, maxDays = data.maxDays, _a = data.weekLimitInDays, weekLimitInDays = _a === void 0 ? getDefaultWeekLimitInDays(origin) : _a, _b = data.daysPerWeek, daysPerWeek = _b === void 0 ? getDefaultDaysPerWeek(origin) : _b;
    if (minDays === 0 && maxDays === 0) {
        return t('delivered immediately');
    }
    // handle weeks
    if (minDays > 10 || (minDays === 0 && maxDays > weekLimitInDays)) {
        var minWeeks = Math.round(minDays / daysPerWeek);
        var maxWeeks = getMaxWeeks(origin, maxDays, daysPerWeek);
        if (minWeeks === maxWeeks || minWeeks === 0) {
            return t('%s week | %s weeks', [maxWeeks, maxWeeks], maxWeeks > 1);
        }
        // alice uses &nbsp;-&nbsp; nonbreaking spaces we might need those if this goes to two lines
        var weeksWithDash = minWeeks + "-" + maxWeeks;
        return t('%s week | %s weeks', [weeksWithDash, weeksWithDash], true);
    }
    // handle days
    if (minDays === maxDays) {
        return t('%s Business Day | %s Business Days', [maxDays, maxDays], maxDays > 1);
    }
    var daysWithDash = minDays + "-" + maxDays;
    return t('%s Business Day | %s Business Days', [daysWithDash, daysWithDash], true);
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var PRODUCT_SCORE_SORT_TYPE = 'score_product_boost';
var PRICE_SORT_TYPE = 'facet_price';
var DESC_SORT_VALUE = 'desc';
var ASC_SORT_VALUE = 'asc';
var isQualifiedForFreeShipping = function (price, countryCode) {
    var thresholdsByCountry = {
        'it-IT': 30,
        'nl-NL': 20,
        'pl-PL': 150,
        'es-ES': 30,
        'fr-FR': 25,
        'cs-CZ': 800,
        'sk-SK': 30,
        'de-DE': 30,
        'de-AT': 30,
        'de-CH': 49,
    };
    return price >= thresholdsByCountry[countryCode];
};
var formatProduct = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
    var position = _a.position, product = _a.product, defaultSimple = _a.defaultSimple, pdpSimple = _a.pdpSimple, formatOptions = _a.formatOptions, bestSellingSimple = _a.bestSellingSimple, showSimpleIsOnSale = _a.showSimpleIsOnSale;
    var numericPrice = typeof defaultSimple.price === 'number' ? defaultSimple.price : defaultSimple.price.value;
    var numericOriginalPrice = defaultSimple.original_price;
    var price = String(numericPrice);
    var originalPrice = String(numericOriginalPrice);
    var link = pdpSimple ? "/" + product.meta.pdp_url + "?simple=" + pdpSimple.sku : "/" + product.meta.pdp_url;
    var isFreeShipping = false;
    if (formatOptions) {
        var countryCode = formatOptions.countryCode, currency = formatOptions.currency;
        isFreeShipping = isQualifiedForFreeShipping(Number(price), countryCode);
        price = String(formatPrice(countryCode, currency, parseFloat(price)));
        originalPrice = formatPrice(countryCode, currency, parseFloat(originalPrice));
    }
    var moodImageData = defaultSimple.mood_image
        ? {
            productMoodImage: {
                path: defaultSimple.mood_image.path,
                seoUrl: defaultSimple.mood_image.seo_url,
                tag: defaultSimple.mood_image.tag,
            },
        }
        : {};
    return __assign(__assign({ sku: product.meta.sku, simpleSku: defaultSimple.sku, baseImage: (_c = (_b = defaultSimple.image_url) !== null && _b !== void 0 ? _b : product.meta.image_url) !== null && _c !== void 0 ? _c : '', name: product.meta.name, altTag: defaultSimple.alt_tag || product.meta.alt_tag, brand: product.meta.brand, blackFriday: !!product.meta.black_friday_top_deal, productDataSheetSRC: (_d = defaultSimple.product_data_sheet_url) !== null && _d !== void 0 ? _d : '', cyberMonday: !!product.meta.cyber_monday_top_deal, isSustainable: product.meta.is_sustainable, link: link, simplesCount: Object.keys(product.simples).length, quantityBadge: (_e = product.meta.quantity_badge_number) !== null && _e !== void 0 ? _e : 0, position: position, price: price, numericPrice: Number(numericPrice), originalPrice: originalPrice, numericOriginalPrice: numericOriginalPrice, isFreeShipping: isFreeShipping, soldOut: !!product.meta.soldout, productImage: {
            path: (_g = (_f = defaultSimple.image) === null || _f === void 0 ? void 0 : _f.path) !== null && _g !== void 0 ? _g : '',
            seoUrl: (_j = (_h = defaultSimple.image) === null || _h === void 0 ? void 0 : _h.seo_url) !== null && _j !== void 0 ? _j : '',
            tag: (_l = (_k = defaultSimple.image) === null || _k === void 0 ? void 0 : _k.tag) !== null && _l !== void 0 ? _l : 'reg',
        }, bestSellingImage: {
            path: (_o = (_m = bestSellingSimple === null || bestSellingSimple === void 0 ? void 0 : bestSellingSimple.meta.image) === null || _m === void 0 ? void 0 : _m.path) !== null && _o !== void 0 ? _o : '',
            seoUrl: (_q = (_p = bestSellingSimple === null || bestSellingSimple === void 0 ? void 0 : bestSellingSimple.meta.image) === null || _p === void 0 ? void 0 : _p.seo_url) !== null && _q !== void 0 ? _q : '',
            tag: (_s = (_r = bestSellingSimple === null || bestSellingSimple === void 0 ? void 0 : bestSellingSimple.meta.image) === null || _r === void 0 ? void 0 : _r.tag) !== null && _s !== void 0 ? _s : 'reg',
        } }, moodImageData), { energyEfficiencyLabel: (_t = product.meta.energy_efficiency) === null || _t === void 0 ? void 0 : _t.label, isNew: !!product.meta.is_new, isAvailable: defaultSimple.available, size: defaultSimple.filter_size, quantity: defaultSimple.quantity, showSimpleIsOnSale: showSimpleIsOnSale });
};
var applySorting = function (sorting, simples) {
    var defaultSimple = simples[0];
    var mostExpensiveSimple = simples[simples.length - 1];
    var name = sorting.name, order = sorting.order;
    var sortedByPriceAscending = name === PRICE_SORT_TYPE && order === ASC_SORT_VALUE;
    var sortedByPriceDescending = name === PRICE_SORT_TYPE && order === DESC_SORT_VALUE;
    var sortedByProductScore = name === PRODUCT_SCORE_SORT_TYPE;
    var simpleOptions = { defaultSimple: defaultSimple, pdpSimple: defaultSimple };
    if (sortedByProductScore || sortedByPriceAscending) {
        var availableSimples = simples.filter(function (simple) { return simple.available; });
        var cheapestAvailableSimple = availableSimples.length ? availableSimples[0] : defaultSimple;
        simpleOptions = { defaultSimple: defaultSimple, pdpSimple: cheapestAvailableSimple };
    }
    if (sortedByPriceDescending) {
        simpleOptions = { defaultSimple: mostExpensiveSimple, pdpSimple: mostExpensiveSimple };
    }
    return simpleOptions;
};
var ProductFormatter = function (position, product, sortingParams, filters, formatOptions) {
    var simples = Object.keys(product.simples).map(function (sku) { return (__assign(__assign({}, product.simples[sku].meta), { sku: sku })); });
    var simplesSortedByPriceAscending = simples.sort(function (a, b) {
        return a.price >= b.price ? 1 : -1;
    });
    var cheapestSimple = simplesSortedByPriceAscending[0], otherSimples = simplesSortedByPriceAscending.slice(1);
    // Cannot depend on API cheapest simple SKU as bestseller API does not have it.
    var bestSellerSKU = product.meta.best_selling_simple_sku;
    var simpleOptions = {
        defaultSimple: __assign(__assign({}, cheapestSimple), { bestSellerSKU: bestSellerSKU }),
    };
    var sizeFilters = ['facet_filter_size', 'facet_length', 'facet_width', 'facet_depth', 'facet_height'];
    if (filters && Object.keys(filters).some(function (filterKey) { return sizeFilters.includes(filterKey); })) {
        simpleOptions.pdpSimple = simpleOptions.defaultSimple;
    }
    if (sortingParams &&
        sortingParams.name === PRICE_SORT_TYPE &&
        sortingParams.order === DESC_SORT_VALUE &&
        simples.length > 1) {
        simpleOptions = applySorting(sortingParams, simplesSortedByPriceAscending);
    }
    var bestSellingSimple = product.simples[bestSellerSKU || ''];
    var showSimpleIsOnSale = otherSimples.some(function (otherSimple) { return otherSimple.price !== otherSimple.original_price; });
    return formatProduct({
        position: position,
        product: product,
        defaultSimple: simpleOptions.defaultSimple,
        pdpSimple: simpleOptions.pdpSimple,
        formatOptions: formatOptions,
        bestSellingSimple: bestSellingSimple,
        showSimpleIsOnSale: showSimpleIsOnSale,
    });
};

exports.ProductFormatter = ProductFormatter;
exports.formatDate = formatDate;
exports.formatDeliveryTime = formatDeliveryTime;
exports.formatPrice = formatPrice;
exports.formatProduct = formatProduct;
exports.normalizeWhitespaces = normalizeWhitespaces;
//# sourceMappingURL=index.js.map
